import {
    roleActions,
    roleThunks as defaultThunks,
    roleSelectors as defaultSelectors,
    roleReducer,
} from './Role-slice';
import * as thunks from './Role-thunks';
import * as selectors from './Role-selectors';

const roleThunks = { ...defaultThunks, ...thunks };
const roleSelectors = { ...defaultSelectors, ...selectors };

export { roleSelectors, roleActions, roleThunks, roleReducer };
